import { ProgramPolicyItem } from "@/views/tower/v2/objects/ProgramsLibraryPanel";

export const DISPLAY_OPTIONS_UPDATED = 'display-options-updated';
export const ADD_POLICY = 'add-policy';
export const ADD_CUSTOM_POLICY = 'add-custom-policy';
export const ADD_ALL_POLICIES = 'add-all-policies';
export const REMOVE_POLICY = 'remove-policy';
export const REMOVE_CUSTOM_POLICY = 'remove-custom-policy';
export const UPDATE_POLICY = 'update-policy';
export const UPDATE_POLICY_CHILDREN = 'update-policy-children';
export const LOAD_CANVAS_JSON = 'load-canvas-json';
export const SAVE_TOWER = 'save-tower';
export const UPDATE_TOWER = 'update-tower';
export const DELETE_TOWER = 'delete-tower';
export const UNDO_TOWER = 'undo-tower';
export const REDO_TOWER = 'redo-tower';
export const PUBLISH_POLICY = 'publish-policy';
export const SYNC_TOWER_LIBRARY_PANE = 'sync-tower-library-pane';
export const SYNC_TOWER_SCALE_POLICIES = 'sync-tower-scale-policies';
export const UPDATE_TOWER_VERSIONS = 'update-tower-versions';
export const TOWER_SCALE_MODE_CHANGED = 'tower-scale-mode-changed';
export const ISSUE_POLICY_EDITOR_SAVE = 'issue-policy-editor-save';
export const CHANGE_OBJECT_LAYER = 'change-object-layer';
export const EXPAND_POLICY_EDITOR = 'expand-policy-editor';

export const UPDATE_TOWER_CUSTOM_POLICY = 'update-tower-custom-policy';


// tower visualizer events
export const TOWER_VISUALIZER_SET_CANVAS_TO_CURRENT = 'tower-visualizer-set-canvas-to-current';

export interface UpdateTowerCustomPolicyPayload {
  policyRectId: string;
  policy: ProgramPolicyItem;
}

const policyEvents = {
  addPolicy: ADD_POLICY,
  addCustomPolicy: ADD_CUSTOM_POLICY,
  addAllPolicies: ADD_ALL_POLICIES,
  removePolicy: REMOVE_POLICY,
  removeCustomPolicy: REMOVE_CUSTOM_POLICY,
  updatePolicy: UPDATE_POLICY,
  updateTowerCustomPolicy: UPDATE_TOWER_CUSTOM_POLICY,
  publishPolicy: PUBLISH_POLICY,
} as const

const towerEvents = {
  loadCanvasJson: LOAD_CANVAS_JSON,
  saveTower: SAVE_TOWER,
  updateTower: UPDATE_TOWER,
  deleteTower: DELETE_TOWER,
  undoTower: UNDO_TOWER,
  redoTower: REDO_TOWER,
  syncTowerLibraryPane: SYNC_TOWER_LIBRARY_PANE,
  syncTowerScalePolicies: SYNC_TOWER_SCALE_POLICIES,
  displayOptionsUpdated: 'display-options-updated',
  objectModified: 'object:modified',
  canvasLoaded: 'canvas:loaded',
  updateTowerVersions: UPDATE_TOWER_VERSIONS,
} as const

const visualizerEvents = {
  towerVisualizerSetCanvasToCurrent: TOWER_VISUALIZER_SET_CANVAS_TO_CURRENT,
} as const

export const customEvents = {
  DISPLAY_OPTIONS_UPDATED,
  ...policyEvents,
  ...towerEvents,
  ...visualizerEvents,
} as const;

export type CustomEvent = (typeof customEvents)[keyof typeof customEvents];

export type ChangeObjectLayerOptions = 'send-to-back' | 'bring-to-front' | 'send-backward' | 'bring-forward';
